import { ColumnProps } from "antd/es/table";
import {
    ReadOutlined,
    DeleteOutlined,
    SearchOutlined,
} from '@ant-design/icons'
import { Button, Input, Space } from "antd";
import { FilterConfirmProps } from "antd/es/table/interface";
import { set } from "date-fns";

const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
) => {
    confirm();
};

export const filterDropDownInputs = ({ nameInputForm, placeholder, selectedKeys, setSelectedKeys, confirm, clearFilters, close }: any) => {
    return (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
                placeholder={placeholder}
                name={nameInputForm}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys as string[], confirm)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Procurar
                </Button>
                <Button
                    onClick={() => {
                        setSelectedKeys([''])
                        confirm();
                        close();
                    }}
                    size="small"
                    style={{ width: 90 }}
                >
                    Resetar
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    Fechar
                </Button>
            </Space>
        </div>
    )
};

export const getColumnSearchProps = (name: string, placeholder: string): ColumnProps<any> => {
    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => filterDropDownInputs({
            nameInputForm: name,
            placeholder,
            selectedKeys,
            setSelectedKeys,
            confirm,
            clearFilters,
            close,
        }),
        filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value: any, record) => record[name]
            ? record[name].toString().toLowerCase().includes(value.toLowerCase())
            : '',
    }
};